import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MobileContainer } from '@components/organism/MobileContainer';
import { RecoverPasswordForm } from '@components/molecules/RecoverPasswordForm';
import { RecoverPasswordToken } from '@components/molecules/RecoverPasswordToken';
import { ResetPasswordForm } from '@components/molecules/ResetPasswordForm';

type Step = 'email' | 'token' | 'reset';

export function RecoverPassword() {
    const location = useLocation();

    const prefilledEmail = location.state?.email ?? '';

    const [step, setStep] = useState<Step>('email');
    const [email, setEmail] = useState<string>(prefilledEmail);
    const [token, setToken] = useState<string>('');

    return (
        <MobileContainer>
            <>
                {step === 'email' && (
                    <RecoverPasswordForm
                        email={email}
                        onSuccess={(email) => {
                            setEmail(email);
                            setStep('token');
                        }}
                    />
                )}

                {step === 'token' && (
                    <RecoverPasswordToken
                        email={email}
                        onNext={(token) => {
                            setToken(token);
                            setStep('reset');
                        }}
                    />
                )}

                {step === 'reset' && <ResetPasswordForm token={token} />}
            </>
        </MobileContainer>
    );
}
